module.exports = __webpack_public_path__ + "static/media/55.ae8b6864.jpg";